export const UNMET_NEEDS_MAP = {
  "Excessive Steroid Use on Double Therapy": "Pct_ICS_LABA_High_Steroid_Usage",
  "Failure to Escalate after more than 3 ED/ER visits": "Pct_Failure_To_Escalate_With_3_Exacerbations",
  "Delay from Double to Advanced Therapy": "Pct_ICS_LABA_Escalation_Delay",
  "Biologic before triple": "Pct_Biologic_Before_Triple",
  "Open triple therapy": "Pct_ICS_LABA_With_LAMA"
};

export const BACKEND_TO_FRONTEND_UNMET_MAP = Object.fromEntries(
  Object.entries(UNMET_NEEDS_MAP).map(([displayName, backendKey]) => [backendKey, displayName])
);

export const UNMET_NEEDS_DISPLAY_NAMES = Object.keys(UNMET_NEEDS_MAP);

export const DEFAULT_PRIORITY_UNMET_NEED = UNMET_NEEDS_DISPLAY_NAMES[0];
